var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.5C11.866 15.5 15 12.366 15 8.5C15 4.63401 11.866 1.5 8 1.5C4.13401 1.5 1 4.63401 1 8.5C1 9.75544 1.3305 10.9337 1.90924 11.9525L1 15.5L4.65743 14.6519C5.65069 15.1927 6.78946 15.5 8 15.5ZM8 14.4231C11.2712 14.4231 13.9231 11.7712 13.9231 8.5C13.9231 5.22878 11.2712 2.57692 8 2.57692C4.72878 2.57692 2.07692 5.22878 2.07692 8.5C2.07692 9.76303 2.47225 10.9337 3.14592 11.8951L2.61538 13.8846L4.63997 13.3785C5.59468 14.0373 6.75229 14.4231 8 14.4231Z",
    fill: "#BFC8D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8C14 11.3137 11.3137 14 8 14C6.73608 14 5.56344 13.6092 4.59633 12.9418L2.54545 13.4545L3.08288 11.4392C2.40046 10.4653 2 9.27944 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z",
    fill: "url(#paint0_linear_430_10923)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 9.25544 1.3305 10.4337 1.90924 11.4525L1 15L4.65743 14.1519C5.65069 14.6927 6.78946 15 8 15ZM8 13.9231C11.2712 13.9231 13.9231 11.2712 13.9231 8C13.9231 4.72878 11.2712 2.07692 8 2.07692C4.72878 2.07692 2.07692 4.72878 2.07692 8C2.07692 9.26303 2.47225 10.4337 3.14592 11.3951L2.61538 13.3846L4.63997 12.8785C5.59468 13.5373 6.75229 13.9231 8 13.9231Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25001 4.75019C6.08358 4.4159 5.82826 4.44549 5.57034 4.44549C5.10938 4.44549 4.39062 4.99763 4.39062 6.02522C4.39063 6.86738 4.76172 7.78926 6.01221 9.1683C7.21902 10.4992 8.80469 11.1877 10.1211 11.1642C11.4375 11.1408 11.7083 10.008 11.7083 9.6254C11.7083 9.45584 11.6031 9.37124 11.5306 9.34825C11.082 9.13296 10.2547 8.73182 10.0664 8.65645C9.87816 8.58108 9.77986 8.68302 9.71876 8.73848C9.54804 8.90117 9.20963 9.38063 9.09376 9.48848C8.97789 9.59632 8.80514 9.54174 8.73325 9.50097C8.46872 9.39482 7.75146 9.07578 7.17973 8.52156C6.47266 7.83613 6.43117 7.60031 6.29795 7.3904C6.19138 7.22247 6.26958 7.11943 6.3086 7.07441C6.46095 6.89863 6.6713 6.62724 6.76564 6.49238C6.85997 6.35751 6.78508 6.15275 6.74015 6.02522C6.54689 5.47675 6.38316 5.01762 6.25001 4.75019Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_430_10923",
    x1: 13.25,
    y1: 3.5,
    x2: 2,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BD066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27B43E"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.317feed22d4ae477411ea55425d2c872.svg";
export { ForwardRef as ReactComponent };